import { spawn } from "node:child_process"

type SpawnAndWaitOptions = {
  cwd?: string
  env?: NodeJS.ProcessEnv
  stdinData?: string
}

export async function spawnAndWait(
  command: string,
  args: string[],
  options: SpawnAndWaitOptions = {},
): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    const child = spawn(command, args, {
      cwd: options.cwd,
      env: options.env ?? process.env,
      stdio: ["pipe", "inherit", "inherit"],
    })

    child.once("error", error => reject(error))
    child.once("close", code => {
      if (code === 0) {
        resolve()
      } else {
        reject(new Error(`Command failed (${code ?? "unknown"}): ${command} ${args.join(" ")}`))
      }
    })

    if (child.stdin) {
      if (options.stdinData !== undefined) {
        child.stdin.write(options.stdinData)
      }

      child.stdin.end()
    }
  })
}
